import { useLocation } from "react-router-dom";
import { Text, Dialog, Headline } from "./";
import type { SharedFormatMessage } from "@akina/infra";

const EXCLUDED_PATHS = [
  "/reactions",
]

const SUBTITLE_MESSAGE = { id: "shared.dialogs.useOnDesktopDialog.subtitle" } as const;
const TITLE_MESSAGE = { id: "shared.dialogs.useOnDesktopDialog.title" } as const;

function isPathExcluded(pathname: string): boolean {
  return EXCLUDED_PATHS.some(path => pathname.startsWith(path));
}

export const UseOnLargerScreenModal = ({ formatMessage }: { formatMessage: SharedFormatMessage }) => {
  const pathname = useLocation().pathname;
  const isExcluded = isPathExcluded(pathname);
  if (isExcluded) return null;

  return (
    <Dialog className="max-w-desktop-modal" open={true} withClose={false}>
      <Headline size="2xl">{formatMessage(TITLE_MESSAGE)}</Headline>
      <Text className="mt-12">{formatMessage(SUBTITLE_MESSAGE)}</Text>
    </Dialog>
  );
};

